import React from "react";

function Footer() {
  return (
    <footer className="ops-footer">
      <span>EDWIN "E" ARZU // E-OPS SYSTEM</span>
      <span>Keyboard: H Home / P Projects / C Contact</span>
    </footer>
  );
}

export default Footer;
